export const MATCHER_NO_SPECIAL_SYMBOLS_REGEX = /^[A-Za-z\s\-']*$/;
